import { detectEnv } from '@/shared/detect';
import { useSettingsStore } from '@/stores/modules/settings';
import type { Pinia } from 'pinia';
import type VueRouter from 'vue-router';

export default function appInfoGuard(router: VueRouter, pinia: Pinia) {
  const settingsStore = useSettingsStore(pinia);

  router.beforeEach(async (to, from, next) => {
    if (detectEnv.yxh && !settingsStore.appInfoAcquired) {
      try {
        await settingsStore.getAppInfo();
      } catch {}
    }

    next();
  });
}
